// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2xBQZ","buttons":"PendingPaymentAlert_buttons__2A0uP"};